export default __webpack_public_path__ + "images/a2cfda6e0b1a2c78f5428eba4fe908de-4_web_1919x543.webp";